export default [
  {
    label: 'Why STATECS?',
    href: '#why-statecs',
  },
  {
    label: 'Our Values',
    href: '#our-values',
  },
  {
    label: 'Meet Our Core Team',
    href: '#meet-our-team',
  },
];
